import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaExclamationTriangle } from 'react-icons/fa';
import Modal from '../../../components/Utils/ModalShow';

// Activation de l'option « Remettre en attente » sur les mois clôturés (Support#40) :
// action hyper sensible. L'option n'est activée qu'après avoir lu l'avertissement
// ET coché la case de reconnaissance du risque.
const EnableReopenClosedMonthModal = ({ isOpen, onClose, onConfirm }) => {
    const { t } = useTranslation();
    const [acknowledged, setAcknowledged] = useState(false);

    useEffect(() => {
        if (isOpen) setAcknowledged(false);
    }, [isOpen]);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={t('companySettings.enableReopenTitle')}
            headerIcon={<FaExclamationTriangle className="text-red-600" size={20} />}
            size={560}
            footer={
                <>
                    <button
                        type="button"
                        className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200 font-medium"
                        onClick={onClose}
                    >
                        {t('basePrimeForm.cancel')}
                    </button>
                    <button
                        type="button"
                        className="px-6 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={onConfirm}
                        disabled={!acknowledged}
                    >
                        {t('companySettings.enableReopenConfirm')}
                    </button>
                </>
            }
        >
            <div className="p-6 space-y-4">
                <div className="p-4 bg-red-50 border border-red-200 rounded-lg text-sm text-red-800">
                    {t('companySettings.enableReopenWarning')}
                </div>
                <label className="flex items-start space-x-3 cursor-pointer">
                    <input
                        type="checkbox"
                        checked={acknowledged}
                        onChange={(e) => setAcknowledged(e.target.checked)}
                        className="w-4 h-4 mt-0.5 text-red-600 border-gray-300 rounded focus:ring-red-600"
                    />
                    <span className="text-sm font-medium text-gray-700">
                        {t('companySettings.enableReopenAcknowledge')}
                    </span>
                </label>
            </div>
        </Modal>
    );
};

export default EnableReopenClosedMonthModal;
